

export default {
    namespaced:true,
    state: {
      /**首页所有资源数据 */
      sysDataList:{},
      /**强制刷新标识 */
      isRouterAlive:true
    },
    mutations: {
      /**修改首页所有资源数据 */
      changeData(state,data){
        state.sysDataList=data;
      },
      changeRouteAlive(state,data){
        state.isRouterAlive=data;
      }
    },
    actions: {
       
    }
};